// extracted by mini-css-extract-plugin
export default {"chatCancel":"chatInput_chatCancel__IgGBK","chatTextInput":"chatInput_chatTextInput__mg9bI"};